// src/components/createpost/PostStyleSelector.js

import React from 'react';
import './PostStyleSelector.css';
import { POST_STYLE_THEMES } from '../../constants/postStyleThemes';

function PostStyleSelector({
  open = false,
  selectedTheme = 'normal',
  onSelectTheme,
  onClose,
}) {
  if (!open) return null;

  const handleSelect = (themeKey) => {
    onSelectTheme(themeKey);
    onClose?.();
  };

  return (
    <div className="post-style-drawer-overlay" onClick={onClose}>
      <div
        className="post-style-drawer"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="post-style-drawer-grabber" />

        <div className="post-style-selector-head">
          <div>
            <h3>Choose style</h3>
            <p>Make your post stand out in the feed.</p>
          </div>

          <button
            type="button"
            className="post-style-selector-close"
            onClick={onClose}
            aria-label="Close style selector"
          >
            ×
          </button>
        </div>

        <div className="post-style-theme-list">
          {POST_STYLE_THEMES.map((theme) => {
            const active = selectedTheme === theme.key;

            return (
              <button
                key={theme.key}
                type="button"
                className={`post-style-theme-card ${active ? 'is-active' : ''}`}
                onClick={() => handleSelect(theme.key)}
              >
                <span className={`post-style-theme-preview ${theme.previewClass}`}>
                  <span className="post-style-preview-line long" />
                  <span className="post-style-preview-line medium" />
                  <span className="post-style-preview-line short" />
                </span>

                <span className="post-style-theme-info">
                  <span className="post-style-theme-title-row">
                    <strong>{theme.label}</strong>
                    <em>{theme.priceLabel}</em>
                  </span>

                  <span className="post-style-theme-desc">
                    {theme.description}
                  </span>
                </span>

                <span className="post-style-theme-check">
                  {active ? '✓' : ''}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PostStyleSelector;
